import ApiServiceV6Core from '@/helpers/api.service.v6core';
const APIV6Core = new ApiServiceV6Core();


export const state = {
    loadPromoList: [],
    loadPromoPageInfo: {
        total: 0
    },
}

export const mutations = {
    UPDATE_LOADPROMO_LIST(state, list) {
    state.loadPromoList = list;
  },
  UPDATE_LOADPROMO_PAGE_INFO(state, total) {
    state.loadPromoPageInfo.total = total;
  },
}

export const actions = {
    actionCoreEloadSKUMasterAPIPOST(context, {params, action}) {
        return new Promise((resolve, reject) => {
            // console.log("actionCoreEloadSKUMasterAPIPOST params:", params);
            // Use normal API service (with preloader)
            APIV6Core.post(`/eload/sku/master/${action}`, params)
            .then((response) => {
                switch(action) {
                    case 'list':
                        context.commit('UPDATE_LOADPROMO_LIST', response.data.message.rows);
                        context.commit('UPDATE_LOADPROMO_PAGE_INFO', response.  data.message.pageInfo.total);
                        break;
                  
                }
                resolve(response.data);
            })
            .catch((error) => {
                reject(error);
            });
        });
    },
}

export const getters = {
    
}